import _classCallCheck from "/workspace/build/buildkite/cchh/build-employer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/build/buildkite/cchh/build-employer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/workspace/build/buildkite/cchh/build-employer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workspace/build/buildkite/cchh/build-employer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/workspace/build/buildkite/cchh/build-employer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/workspace/build/buildkite/cchh/build-employer-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/* icon/UI 24px/Menu (hamburger, navigation).svg: width 24px x height 24px */
var DlsIconMenu =
/*#__PURE__*/
function (_HTMLElement) {
  _inherits(DlsIconMenu, _HTMLElement);

  function DlsIconMenu() {
    _classCallCheck(this, DlsIconMenu);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconMenu).apply(this, arguments));
  }

  _createClass(DlsIconMenu, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 24 24\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" d=\"M2 6h20M2 12h20M2 18h20\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-menu';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconMenu;
}(_wrapNativeSuper(HTMLElement));

export { DlsIconMenu as default };
DlsIconMenu.define();